import IF from "./IfComponent";

export default IF;